import { IOpenGymReservation } from "./OpenGym";

export interface IClassEvent {
  id: number;
  name: string;
  occuranceDate: string;
  instructorFullName: string;
  roomName: string;
  credits: number;
  priceForClubPass: number;
  duration: number;
  isAvailable: boolean;
  isAlreadyBooked: boolean;
  type: ClubpassEventType;
  hasLastMinDiscount: boolean;
  isLoyaltyDealAvailable: boolean;
}

export interface ICreateReservationModel {
  gymListingId: string;
  classEventId: number;
  useLoyaltyPoints: boolean;
}

export interface ICancelReservationModel {
  gymListingId: string;
  reservationId: number;
}

export enum ClubpassEventType {
  GROUP_CLASS = "GROUP_CLASS",
  OPEN_GYM = "OPEN_GYM",
}

export interface IClassCategory {
  createdAt: string;
  updatedAt: string;
  id: string;
  name: string;
}

export enum EClassLevels {
  Beginner = "Beginner",
  Intermediate = "Intermediate",
  Advanced = "Advanced",
  MixedAbility = "MixedAbility",
  Gentle = "Gentle",
}

export enum ReservationStatusTypes {
  Active,
  Inactive,
  Canceled,
  Attending,
}

export interface IClassEventTimeRange {
  id: string;
  from: string;
  to: string;
}

export interface IClassEventReservation {
  id: number;
  roomName: string;
  occuranceDate: string;
  classEventId: number;
  duration: number;
  creditsValue: number;
  userId: string;
  createdAt: string;
  refundType: boolean;
  attended: boolean;
  status: ReservationStatusTypes;
  canBeCancelled?: boolean;
  gymName?: string;
  address?: string;
  gymListingId?: string;
  gymListingImage?: string | null;
  canLeaveComment?: boolean;
  userFullName?: string;
  statusLabel?: string;
  type: ClubpassEventType.GROUP_CLASS;
}

export type TUpcomingClassEvent = IClassEventReservation | IOpenGymReservation;
export type TAttendedClassEvent = TUpcomingClassEvent;

export const CLASS_LEVEL_CODES: Record<EClassLevels, number> = {
  [EClassLevels.Beginner]: 0,
  [EClassLevels.Gentle]: 1,
  [EClassLevels.Intermediate]: 2,
  [EClassLevels.Advanced]: 3,
  [EClassLevels.MixedAbility]: 4,
};
